import getValueByString from "../../../Utils/Form/FormDynamic/Utils/getValueByString";

const generatingDefaultFields = (schema = [], tmpFields, path = '', padding = 0, entityId, autofocus = true, prevSchema, isArr, responseValues) => {
    let fieldAutofocus = autofocus;
    schema.forEach((field) => {
        let fieldPath = path.length > 0 ? `${path}.${field.name}` : field.name;
        let fieldValue = responseValues ? getValueByString(responseValues, fieldPath) : true;
        const isObject = isObjectType(field.type);
        if (responseValues) {
            field.disabled = true;
        }
        //set disable = true
        if (field.disabled === false || !field.disabled) {
            field.autofocus = fieldAutofocus;
            fieldAutofocus = false;
        }

        //create field object
        let simpleField = {
            type: 'field',
            properties: entityId ?
                {
                    path: isArr ? field.name : `${entityId}.${fieldPath}`,
                    ...field
                } :
                {
                    path: fieldPath,
                    ...field
                },
            styles: [
                {width: '350px', margin: '', fullWidth: false, inputType: "horizontal"},
                {width: '200px', margin: `0px 0px 0px ${padding}px`}]
        };


        //if one of (entityMixed, entityEmbedded, object) types
        if (isObject) {
            let label = {
                type: 'label',
                properties: {label: field.label, hidden: field.hidden},
                styles: [{padding: `0px 0px 0px ${padding}px`}]
            };
            let nestedPath = path.length > 0 ? `${path}.${field.name}` : field.name;
            let properties = field.schema ? field.schema.properties : [];

            if (field.isArray) {
                const arrayWrapperPath = entityId ? `${entityId}.${nestedPath}` : nestedPath;
                let fieldsArrayWrapper = {
                    type: "fieldArray",
                    name: field.name,
                    properties: {
                        path: arrayWrapperPath,
                        arrayType: field.arrayType || 'vertical',
                        hidden: field.hidden
                    },
                    styles: [{margin: padding}],
                    children: []
                };
                const embeddedComponent = {
                    vertical: {
                        type: 'fieldArray',
                        name: field.name,
                        styles: [{width: '100%'}],
                        properties: {
                            creatable: true,
                            removable: true,
                            path: arrayWrapperPath,
                        },
                        children: []
                    },
                    horizontal: {
                        type: "fieldArray",
                        name: field.name,
                        properties: {
                            path: arrayWrapperPath,
                            arrayType: field.arrayType || 'vertical',
                            hidden: field.hidden
                        },
                        styles: [{margin: padding}],
                        children: []
                    }
                };
                switch (field.type) {
                    case 'entityMixed':
                        let mixedField = {
                            field: {
                                name: field.name,
                                label: field.label,
                                type: 'field',
                                styles: [
                                    {width: '350px', margin: '', fullWidth: false},
                                    {width: '200px', margin: `0px 0px 0px ${padding}px`}
                                ],
                                properties: {
                                    path: field.name,//entityId ? `${entityId}.${nestedPath}` : nestedPath,
                                    arrayType: field.arrayType || 'vertical',
                                    schema: field.schema,
                                    ...field,
                                },
                            },
                            container: {
                                vertical: {
                                    type: 'forEach',
                                    styles: [{width: '100%'}],
                                    properties: {
                                        creatable: true,
                                        removable: true,
                                        editScreen: entityId,
                                        path: arrayWrapperPath,
                                    },
                                    children: []
                                },
                                horizontal: {
                                    type: "fieldArray",
                                    name: field.name,
                                    properties: {
                                        path: arrayWrapperPath,
                                        arrayType: field.arrayType || 'vertical',
                                        hidden: field.hidden
                                    },
                                    styles: [{margin: padding}],
                                    children: []
                                }
                            }
                        };
                        tmpFields.push(mixedField.field);
                        tmpFields.push(mixedField.container[field.arrayType || 'vertical']);
                        generatingDefaultFields(
                            properties,
                            mixedField.container[field.arrayType || 'vertical'].children,
                            nestedPath,
                            padding + 10,
                            entityId,
                            fieldAutofocus,
                            properties,
                            true
                        );
                        break;
                    case 'entityEmbedded':
                        tmpFields.push(label);
                        if (!field.schema) {
                            let fieldsInfinityWrapper = {
                                type: "fieldInfinity",
                                properties: {
                                    path: arrayWrapperPath,
                                    schema: prevSchema,
                                    field: field,
                                    padding: isNaN(padding) ? 0 : padding,
                                    isArray: Boolean(field.isArray),
                                    valueIndex: 0
                                },
                                styles: [{margin: padding}]
                            };
                            tmpFields.push(fieldsInfinityWrapper);
                            generatingDefaultFields(
                                properties,
                                fieldsInfinityWrapper.children,
                                nestedPath,
                                padding + 10,
                                entityId,
                                fieldAutofocus,
                                prevSchema,
                                true
                            );
                            break
                        }
                        tmpFields.push(embeddedComponent[field.arrayType || 'vertical']);
                        const newProperties = field.hidden ? properties.map(i => ({
                            ...i,
                            hidden: field.hidden
                        })) : properties;
                        generatingDefaultFields(
                            newProperties,
                            embeddedComponent[field.arrayType || 'vertical'].children,
                            nestedPath,
                            padding + 10,
                            entityId,
                            fieldAutofocus,
                            properties,
                            true
                        );
                        break;
                    case 'object':
                        tmpFields.push(label);
                        tmpFields.push(fieldsArrayWrapper);
                        generatingDefaultFields(
                            field.properties || [],
                            fieldsArrayWrapper.children,
                            nestedPath,
                            padding + 10,
                            entityId,
                            fieldAutofocus,
                            properties,
                            true
                        );
                        break;
                    default:
                        break;
                }
                return;
            }

            let newNested = isArr ? field.name : nestedPath;
            let newEntityId = isArr ? null : entityId;
            const newProperties = field.hidden ? properties.map(i => ({...i, hidden: field.hidden})) : properties;
            let containerPath = entityId ? `${entityId}.${nestedPath}` : nestedPath
            let containerObjectValue = responseValues ? getValueByString(responseValues, nestedPath) : true
            switch (field.type) {
                case 'entityMixed':
                    let mixedField = {
                        name: field.name,
                        label: field.label,
                        type: 'field',
                        styles: [
                            {width: '350px', margin: '', fullWidth: false},
                            {width: '200px', margin: `0px 0px 0px ${padding}px`}
                        ],
                        properties: {
                            path: containerPath,
                            arrayType: field.arrayType || 'vertical',
                            ...field
                        }
                    };
                    containerObjectValue && tmpFields.push(mixedField);
                    containerObjectValue && generatingDefaultFields(
                        newProperties,
                        tmpFields,
                        newNested,
                        padding + 10,
                        newEntityId,
                        fieldAutofocus,
                        properties
                    );
                    break;
                case 'entityEmbedded':
                    containerObjectValue && tmpFields.push(label);
                    //const newProperties = field.hidden ? properties.map(i => ({...i, hidden: field.hidden})) : properties;
                    containerObjectValue && generatingDefaultFields(
                        newProperties,
                        tmpFields,
                        newNested,
                        padding + 10,
                        newEntityId,
                        fieldAutofocus,
                        properties,
                        false,
                        responseValues,
                    );
                    break;
                case 'object':
                    containerObjectValue && tmpFields.push(label);
                    containerObjectValue && generatingDefaultFields(
                        field.properties || [],
                        tmpFields,
                        newNested,
                        padding + 10,
                        newEntityId,
                        fieldAutofocus,
                        properties
                    );
                    break;
                default:
                    console.log('default case');
                    let fieldsInfinityWrapper = {
                        type: "fieldInfinity",
                        properties: {
                            path: containerPath,
                            schema: prevSchema,
                            field: field,
                            padding: isNaN(padding) ? 0 : padding,
                            isArray: Boolean(field.isArray)
                        },
                        styles: [{margin: padding}],
                        children: [
                            {
                                index: 0,
                                type: "fieldInfinityContainer",
                                children: []
                            }
                        ]
                    };
                    containerObjectValue && tmpFields.push(label);
                    containerObjectValue && tmpFields.push(fieldsInfinityWrapper);
                    containerObjectValue && generatingDefaultFields(
                        properties,
                        fieldsInfinityWrapper.children[0].children,
                        nestedPath,
                        padding + 10,
                        entityId,
                        fieldAutofocus,
                        prevSchema
                    );
            }
            return;
        }
        fieldValue && tmpFields.push(simpleField)
    });
};

export default generatingDefaultFields;

function isObjectType(type) {
    return type === 'entityEmbedded' || type === 'entityMixed' || type === 'object'
}